export const DIALOG_MESSAGE = {
  DELETE_CLINIC_DANGER: {
    title: 'Удалить клинику из списка?',
    text: 'Вернуть клинику в список можно будет только через её сайт.',
    confirmText: 'Нет, оставить',
    closeText: 'Да, удалить',
    persistent: true,
  },
}
